import { apiExternal } from '../../config';

export default async function (body) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'x-api-key': 'cFPBG99MAH4xsr0xs1QU94czvOTzTYec3jUTWsql',
  };

  const { url, method, path } = apiExternal.postFormError;
  await fetch(url + path, { headers, method, body });
}
